module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/flat-lays/flat-lay-01-b669f5379c8002b21cca060a6ac6fd82.jpg";